export default {
    default: {
        fetchModelsPeriod: 30000, // définit le temps en ms entre chaque fetch
    },
    listModels: {
        users: {
            url: 'user/',
            fetch: false
        },
        entities: {
            url: 'entity/',
        },
        takers: {
            url: 'taker/',
            scoped: true,
            filter: {
                archived: false
            }
        },
        feeds: {
            url: 'feed/',
            scoped: true,
            filter: {
                archived: false
            }
            // fetchPeriod: 2000,
        },
        configurations: {
            url: 'configuration/',
            scoped: true,
            fetch: true,
            filter: {
                cancelled: false,
                archived: false,
                status__in:'FINISHED,FINISHING,PENDING,RUNNING,CONNECTING,CONNECTED,WAIT_UNTIL_COMPLETION,STOP_CURRENT'
            },
            fetchPeriod: 10000,
        },
        tags: {
            url: 'tag/',
            scoped: true,
        },
        events: {
            url: 'event/',
            scoped: true
        },
        universes: {
            url: 'universe/',
            scoped: true
        },
        irds: {
            url: 'ird/',
            scoped: true,
            filter: {
                c_resp_nested: true,
                archived: false,
            },
        },
        manualReceivers: {
            url: 'manual-receiver/',
            scoped: true,
        },
        broadcastRights: {
            url: 'broadcast-right',
            scoped: true,
            fetch: true,
            filter: {
                archived: false,
                revoked: false,
            },
        },
        deliveryFlowStats: {
            url: 'delivery-flow-stat/',
            scoped: true,
            fetch: false,
        },
        receiverPortRequests:{
            url: 'receiver-port-request/',
            fetch: false,
        },
        receiverCreationRequest:{
            url: 'receiver-creation-request/',
            fetch: false,
        },
        receiverModificationRequest:{
            url: 'receiver-modification-request/',
            fetch: false,
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/meta.js